export const ADD_OR_UPDATE_ORGANIZATION = 'ADD_OR_UPDATE_ORGANIZATION';
export const LOAD_ALL_ORGANIZATIONS = 'LOAD_ALL_ORGANIZATIONS';
export const DELETE_ORGANIZATION = 'DELETE_ORGANIZATION';
export const SET_DEFAULT_DOMAIN = 'SET_DEFAULT_DOMAIN';
